export class StampaModelloRameIN {
    idProgetto: number
}
